import { init, animate } from "./scene";

export default function InitializeScene(): void 
{
    const CanvasContainer = document.querySelector("#main")! as HTMLElement;
    init(CanvasContainer);
    animate();
}